let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("42jQL")).then(() => parcelRequire('aE9J2'));